// https://app.growthbook.io/features/pen-7315_v1
export const PEN_7315_V1_CM_INSTRUCTOR_QUOTE_FLAG = 'pen-7315_v1'

export const INSTRUCTOR_QUOTE_LOCATION = 'Instructor Quote'
